import { Field, Form, Formik } from 'formik';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import * as Yup from 'yup';
import PrimaryButton from '../../../../components/Buttons/PrimaryButton/PrimaryButton';
import TextField from '../../../../components/TextField/TextField';
import { setFormData } from '../../../../app/slices/formSlice';
import Page from '../../../../components/Page/Page';
import style from './first.module.scss';
import ReactGoogleAutocomplete from 'react-google-autocomplete';
import CustomGoogleAutoComplete from '../../../../components/CustomGoogleAutocomplete/CustomGoogleAutoComplete';

export const First = ({form:{form}, next}) => {
        const handleButton =  async () => {
          const {validateField} = form;
          const errors = await form.validateForm(form.values);
          const {userName, phoneNumber, salonAddress, salonName }  = errors
          if(!userName && !phoneNumber && !salonAddress && !salonName) {
           next();
          }
          form.setErrors({userName, phoneNumber, salonAddress, salonName })
          form.setTouched({userName: true, phoneNumber: true, salonAddress: true, salonName: true}, false)
        };
        return (
                <>
                <h2 className={clsx(style.page__title)}> Registra il tuo salone</h2>
                <div className={clsx(style.form__fields)}>
                  <Field
                    form={form}
                    name="userName"
                    label="Per prima cosa, come ti chiami?"
                    placeHolder= "Marione"
                    component={TextField}
                  />
                  <Field
                    form={form}
                    name="salonName"
                    label="Inserisci nome esatto  del tuo salone"
                    placeHolder= "New Salon Barber Shop"
                    component={TextField}
                  />
    
                  <Field
                    form={form}
                    name="salonAddress"
                    label="Inserisci l'indirizzo esatto del tuo salone"
                    placeHolder= "Via Fasulla 123, San Marzano sul Sarno"
                    component={CustomGoogleAutoComplete}
                  />
                  <Field
                    form={form}
                    name="phoneNumber"
                    label="Numero di telefono"
                    placeHolder="333 333 3333"
                    type="tel"
                    component={TextField}
                  />
                </div>
                <div className={clsx(style.form__button)}>
                  <PrimaryButton
                    label="Avanti"
                    onClick={handleButton}
                    fullWidth
                  />
                </div>
                </>
        )

}